import { render, staticRenderFns } from "./ChartDown.vue?vue&type=template&id=34dd5170"
import script from "./ChartDown.vue?vue&type=script&lang=js"
export * from "./ChartDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports